/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { alias } from '@ember/object/computed';

import BackfillsService from 'cio/services/backfills';
import NotificationsService from 'cio/services/notifications';
import RouterService from '@ember/routing/router-service';
import { Dropdown as BasicDropdown } from 'ember-basic-dropdown/components/basic-dropdown';
import { next } from '@ember/runloop';
import HydraService from 'cio/services/hydra';

export type TabKey = 'features' | 'tasks';

export default class NotificationsDropdown extends Component {
  @service backfills!: BackfillsService;
  @service notifications!: NotificationsService;
  @service router!: RouterService;
  @service hydra!: HydraService;

  @tracked activeTab = '';

  @alias('backfills.latest.length') backfillsCount!: number;

  @computed('router.currentRoute')
  get tasksTabDisabled() {
    return !this.router.isActive('environment');
  }

  @computed('backfills.hasPending', 'notifications.hasUnviewed')
  get triggerIconClasses() {
    let iconClasses = ['flex', 'items-center', 'justify-center'];

    if (this.backfills.hasPending) {
      iconClasses.push('fly-indicator', 'fly-indicator--warning', 'fly-indicator--breathing');
    } else if (this.notifications.hasUnviewed) {
      iconClasses.push('fly-indicator', 'fly-indicator--success');
    }

    return iconClasses.join(' ');
  }

  _openTab(tab: TabKey) {
    this.activeTab = tab;

    if (tab === 'features') {
      return this.notifications.markAllAsViewed();
    }

    return;
  }

  @action
  openTab(tab: TabKey) {
    return this._openTab(tab);
  }

  @action
  closeDropdown(dd: BasicDropdown) {
    next(dd, dd.actions.close);
  }

  @action
  setDefaultActiveTab() {
    // no pending tasks, unviewed notifications, or not within an environment route: open "What's New?" tab by default
    if ((!this.backfills.hasPending && this.notifications.hasUnviewed) || this.tasksTabDisabled) {
      return this._openTab('features');
    }

    // any other scenario: open tasks tab by default
    return this._openTab('tasks');
  }
}
